import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ---------------------login----------------------------------
export const loginApi = async (data) => {
  // console.log("Got Data in LOginAPi", data);
  // return await axios.post("admin-auth/admin-login", data);
  return await axios.post("/admin/auth/login", data);
};
// ---------------------Verify Otp----------------------------------
export const verifyOtpApi = async (data) => {
  // return await axios.post("admin-auth/verify-otp", data);
  return await axios.post("/admin/auth/verify", data);
};

// --------change password
export const changePasswordApi = async (data, key = "cashsurvey_admin") => {
  return await axios.patch("/admin/auth/change", data, setJwtToken(key));
};

// ---------------------Resend Otp----------------------------------
export const resendOtp = async (data) => {
  return await axios.post("/admin/auth/send", data);
};

// ---------------------forget-password------------------------------
export const forgetApi = async (data) => {
  return await axios.post(`/admin/auth/send`, data);
};
// ---------------------reset-password---------------------------------
export const resetPasswordApi = async (data) => {
  return await axios.post("admin-auth/reset-password", data);
};

// ---------------------logout----------------------------------
export const logoutApi = async (key = "cashsurvey_admin") => {
  return await axios.post("/admin/auth/logout", null, setJwtToken(key));
};
